export default "__VITE_ASSET__DzY$lXx5__"